// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyDTTje-uO8Sj52zDpxO_L_ccNMZB2d7XSs",
    authDomain: "farmresq-com.firebaseapp.com",
    projectId: "farmresq-com",
    storageBucket: "farmresq-com.appspot.com",
    messagingSenderId: "383895220607",
    appId: "1:383895220607:web:a3fd87f1dff6f7db666a4a",
    measurementId: "G-RJW6L3S3Z0"
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
